var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33329 4.99984H16.6666L15.35 16.8498C15.3048 17.2576 15.1108 17.6345 14.8052 17.9082C14.4995 18.1819 14.1036 18.3332 13.6933 18.3332H6.30663C5.89632 18.3332 5.50043 18.1819 5.19475 17.9082C4.88907 17.6345 4.69509 17.2576 4.64996 16.8498L3.33329 4.99984ZM6.12079 2.62234C6.25559 2.33648 6.46888 2.09483 6.7358 1.9256C7.00271 1.75636 7.31225 1.6665 7.62829 1.6665H12.3716C12.6878 1.66634 12.9975 1.75613 13.2646 1.92537C13.5317 2.09462 13.7451 2.33635 13.88 2.62234L15 4.99984H4.99996L6.12079 2.62234ZM11.6666 9.1665V13.3332V9.1665Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 4.99984H18.3333M8.33329 9.1665V13.3332M11.6666 9.1665V13.3332M3.33329 4.99984H16.6666L15.35 16.8498C15.3048 17.2576 15.1108 17.6345 14.8052 17.9082C14.4995 18.1819 14.1036 18.3332 13.6933 18.3332H6.30663C5.89632 18.3332 5.50043 18.1819 5.19475 17.9082C4.88907 17.6345 4.69509 17.2576 4.64996 16.8498L3.33329 4.99984ZM6.12079 2.62234C6.25559 2.33648 6.46888 2.09483 6.7358 1.9256C7.00271 1.75636 7.31225 1.6665 7.62829 1.6665H12.3716C12.6878 1.66634 12.9975 1.75613 13.2646 1.92537C13.5317 2.09462 13.7451 2.33635 13.88 2.62234L15 4.99984H4.99996L6.12079 2.62234Z",
    stroke: "#7FADC0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.51880a7d94a369ef8fe6c8f389838b24.svg";
export { ForwardRef as ReactComponent };